import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "icon"]
  static values = {
    expanded: { type: Boolean, default: false },
    expandLabel: { type: String, default: "Expand" },
    collapseLabel: { type: String, default: "Collapse" }
  }

  connect() {
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    this.sync()
  }

  sync() {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !this.expandedValue)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-90", this.expandedValue)

      const toggleButton = this.iconTarget.closest("button")
      if (toggleButton) {
        toggleButton.setAttribute("aria-expanded", this.expandedValue.toString())
        toggleButton.title = this.expandedValue ? this.collapseLabelValue : this.expandLabelValue
      }
    }
  }
}
